export class Criteria {
    id: number;
    remunerationId: number;
    remunerationName: string;
    scoreLevelId: number;
    scoreLevelName: string;
    minValue: number;
    maxValue: number;
    points: number;
}

